import { Dialog } from '@economic/taco';
import { t, Trans } from '@lingui/macro';
import React from 'react';
import cn from 'classnames';

import ExternalLink from '../../../../../../../shared/components/ExternalLink';
import moneyflowLogo from '../../../../../../market/onboarding/Moneyflow/moneyflow-logo.svg';

interface Props {
    className?: string;
}
export default function MoneyflowOnboardDialogFooter({ className }: Props) {
    return (
        <Dialog.Footer className={cn('flex justify-between bg-grey-light -mb-6 -mx-6 px-6 py-4', className)}>
            <span>
                <Trans>Instant payment is provided by: </Trans>
                <ExternalLink href={t`https://moneyflow.io`}>
                    <img className="h-3 inline ml-1" src={moneyflowLogo} />
                </ExternalLink>
            </span>
            <span>
                <Trans>
                    Instant payment is provided by: <strong>Finanstilsynet</strong>
                </Trans>
            </span>
        </Dialog.Footer>
    );
}
